<script>
	import EditItemDialog from './dialogs/builder/EditItemDialog.svelte';
	import DeleteItemDialog from './dialogs/builder/DeleteItemDialog.svelte';
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();
	export let dataItem;
	export let item;
	export let mobile = false;
	export let customProducts = [];

	const getNumProducts = (size, numProducts) => {
		let arr = [0];
		if (size !== 1 && numProducts !== 1) {
			for (let i = 0; i < size; i++) {
				arr = [...arr, 0];
			}
			return arr;
		} else {
			return arr;
		}
	};
	const editGridItem = () => {
		dataItem.edit = true;
		mobile == true ? (dataItem.device = 'mobile') : (dataItem.device = 'desktop');
		dispatch('edit', dataItem);
	};
	const deleteGridItem = () => {
		dataItem.delete = true;
		mobile == true ? (dataItem.device = 'mobile') : (dataItem.device = 'desktop');
		dispatch('delete', dataItem);
	};
</script>

<div class="grid-item">
	<header>
		<p class="id">
			{dataItem.data.title || dataItem.data.collection}
			{#if dataItem.data.num_products === 12}
				<span>(Carousel)</span>
			{/if}
		</p>
		<span on:pointerdown={(e) => e.stopPropagation()} class="remove">
			<EditItemDialog {customProducts} data={dataItem} on:submit={editGridItem} />
			<DeleteItemDialog data={dataItem} on:submit={deleteGridItem} />
		</span>
	</header>
	<div
		class="grid-item-content"
		class:grid-item-content-mobile={mobile}
		class:grid-item-content-mobile-full={(mobile && dataItem.data.num_products === 12) ||
			(mobile && dataItem.data.num_products === 1)}
		class:grid-item-content-banner={dataItem.data.type == 'banner'}
	>
		{#if dataItem.data.type == 'banner'}
			<img src="/img/grid-builder/banner-img.svg" alt="" />
		{/if}

		{#if mobile == true && dataItem.data.type !== 'banner'}
			{#if dataItem.data.num_products === 12 || dataItem.data.num_products === 1}
				<div class="img-mobile">
					<img src="/img/grid-builder/shopping-bag.svg" alt="" />
				</div>
			{:else}
				{#each Array(dataItem.data.size) as _, index}
					<div class="img-mobile">
						<img src="/img/grid-builder/shopping-bag.svg" alt="" />
					</div>
				{/each}
			{/if}
		{/if}

		{#if !mobile && dataItem.data.type !== 'banner'}
			{#each getNumProducts(item.w, dataItem.data.num_products) as _, index}
				<div class="img-desktop">
					<img src="/img/grid-builder/shopping-bag.svg" alt="" />
				</div>
			{/each}
		{/if}
	</div>
</div>

<style>
	.grid-item {
		background: #fff;
		height: 100%;
		width: 100%;

		padding: 1em;
		border-radius: 2px;
		box-sizing: border-box;
		overflow: hidden;
	}
	.grid-item-content {
		height: calc(100% - 40px);
		display: flex;
		gap: 0.5em;
		justify-content: space-between;
	}
	.grid-item-content-mobile {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 0.3em;
	}
	.grid-item-content-mobile-full {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.grid-item-content-mobile-full .img-mobile {
		width: 100%;
		height: 100%;
	}
	.grid-item-content-banner,
	.img-mobile,
	.img-desktop {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #d0d0d2;
	}
	.img-desktop,
	.img-desktop img,
	.img-mobile img {
		width: 100%;
	}
	.img-desktop img {
		max-width: 90px;
	}
	.img-mobile {
		height: 100%;
		width: 100%;
	}
	.img-mobile img {
		max-width: 50px;
	}

	.remove {
		cursor: pointer;
		font-size: 1em;
		user-select: none;
		display: flex;
	}
	header {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	header p {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.id {
		cursor: pointer;
		user-select: none;
		margin: 0;
		font-size: 1.2em;
	}
	.id span {
		display: inline-block;
		font-size: 12px;
		transform: translateY(-4px);
	}
</style>
